import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
type Crumb = {
  label: string;
  to?: string;
};
export function Breadcrumbs({
  items
}: {
  items: Crumb[];
}) {
  return <nav aria-label="Ruta" className="mb-5" data-id="element-532" data-mp="2ve8en90nzmzr">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-gray-400" data-id="element-533" data-mp="2vd6tuctujm4u">
        {items.map((c, i) => <li key={`${c.label}-${i}`} className="flex items-center gap-1.5" data-id="element-534" data-mp="2zdqpfbyruhov" data-mpi={i}>
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-535" data-mp="34d266kz51n6g" />}
            {c.to ? <Link to={c.to} className="transition-colors duration-150 hover:text-white" data-id="element-536" data-mp="39bwo7kpa77pi">{c.label}</Link> : <span className="font-semibold text-[#D4AF37]" aria-current="page" data-id="element-537" data-mp="3j3sydu4n6oa3">{c.label}</span>}
          </li>)}
      </ol>
    </nav>;
}